import { service } from '@ember/service';
import Controller from '@ember/controller';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingController extends Controller {
  @service billingModals;
  @service billingTransfer;
  @service currentPractice;
}
